<template>
  <router-link
    :to="{ name: 'Orders', params: { orderNumber: this.params.value }}"
    class="text-blue-500 underline"
  >
    {{ params.value }}
  </router-link>
</template>

<script>
export default {
  name: "AdjustmentsReportOrderLink",
};
</script>
